import {combineReducers} from 'redux'
import {logInReducer, logOutReducer} from './authReducers'
import { protondxAdminStatsReducer,
    protondxAdminInfectionStatsReducer,
    protondxAdminOrgListReducer,
    protondxAdminManageOrgReducer,
    protondxAdminExportDataReducer,
    protondxAdminSampleIdsReducer,
    protondxAdminAddSampleIdReducer,
    protondxAdminUpdateSampleIdReducer,
    protondxAdminDeleteSampleIdReducer,
    protondxAdminTestPanelIdsReducer,
    protondxAdminAddTestPanelIdReducer,
    protondxAdminUpdateTestPanelIdReducer,
    protondxAdminDeleteTestPanelIdReducer
} from './protondxAdminReducers'
import { orgAdminStatsReducer,
    orgAdminInfectionStatsReducer,
    orgAdminUserListReducer,
    orgAdminManageUserReducer,
    orgAdminExportDataReducer
 } from './orgAdminReducers'
const rootReducer = combineReducers({
    logIn: logInReducer,
    logOut: logOutReducer,
    protondxAdminStats:protondxAdminStatsReducer,
    protondxAdminInfectionStats:protondxAdminInfectionStatsReducer,
    protondxAdminOrgList:protondxAdminOrgListReducer,
    protondxAdminManageOrg:protondxAdminManageOrgReducer,
    protondxAdminExportData:protondxAdminExportDataReducer,
    protondxAdminSampleIds: protondxAdminSampleIdsReducer,
    protondxAdminAddSampleId: protondxAdminAddSampleIdReducer,
    protondxAdminUpdateSampleId: protondxAdminUpdateSampleIdReducer,
    protondxAdminDeleteSampleId: protondxAdminDeleteSampleIdReducer,
    protondxAdminTestPanelIds: protondxAdminTestPanelIdsReducer,
    protondxAdminAddTestPanelId: protondxAdminAddTestPanelIdReducer,
    protondxAdminUpdateTestPanelId: protondxAdminUpdateTestPanelIdReducer,
    protondxAdminDeleteTestPanelId: protondxAdminDeleteTestPanelIdReducer,
    orgAdminStats:orgAdminStatsReducer,
    orgAdminUserList:orgAdminUserListReducer,
    orgAdminManageUser:orgAdminManageUserReducer,
    orgAdminInfectionStats:orgAdminInfectionStatsReducer,
    orgAdminExportData:orgAdminExportDataReducer
})

export default rootReducer
